import styled from 'styled-components';

var getBorderColor = function getBorderColor(_ref) {
  var error = _ref.error,
      theme = _ref.theme;
  return error ? theme.colorPalette.utilityColors.error : theme.colorPalette.neutralColors.dark.shade_light_3;
};

var getColor = function getColor(_ref2) {
  var error = _ref2.error,
      theme = _ref2.theme;
  return error ? theme.colorPalette.utilityColors.error : theme.colorPalette.primaryColors.main.shade_default;
};

var RadioWrapper = /*#__PURE__*/styled.input.withConfig({
  displayName: "styledComponents__RadioWrapper",
  componentId: "sc-d3yaqu-0"
})(["position:relative;background:", ";border-style:solid;border-width:1px;border-color:", ";border-radius:50%;box-sizing:border-box;width:28px;height:28px;min-width:28px;min-height:28px;vertical-align:bottom;margin-right:12px;appearance:none;-ms-progress-appearance:none;cursor:pointer;::-ms-check{position:relative;background:", ";color:", ";border-style:solid;border-width:1px;border-color:", ";border-radius:50%;box-sizing:border-box;width:28px;height:28px;vertical-align:bottom;cursor:pointer;}&:hover{border-width:2px;&::-ms-check{border-width:2px;}}&:checked{border-color:", ";border-width:2px;&:after{height:10px;width:10px;content:'';position:absolute;border-radius:50%;top:50%;left:50%;transform:translate(-50%,-50%);background-color:", ";}&::-ms-check{border-color:", ";border-width:2px;padding:4px;}}&:disabled{background-color:", ";border-color:", ";border-width:1px;cursor:not-allowed;&:checked{border-width:2px;&::-ms-check{border-width:2px;}}&:after{background-color:", ";}&::-ms-check{background-color:", ";border-color:", ";color:", ";border-width:1px;cursor:not-allowed;&:after{background-color:", ";}}}", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, getBorderColor, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, getColor, getBorderColor, getColor, getColor, getColor, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colorPalette.neutralColors.light.shade_light_2;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colorPalette.neutralColors.light.shade_light_2;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref12) {
  var radioStyle = _ref12.radioStyle;
  return radioStyle;
});
process.env.NODE_ENV !== "production" ? RadioWrapper.displayName = 'RadioWrapper' : void 0;

export { RadioWrapper, RadioWrapper as default };
